import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {AiFillCheckCircle, AiOutlineRotateLeft} from "react-icons/ai";
import {RiCrop2Line, RiDeleteBin6Line} from "react-icons/ri";
import {BiCopy} from "react-icons/bi";
import file from "../img/miobmob.png"
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Image from "../rest/Image";
import ReactCrop, {centerCrop, convertToPixelCrop, makeAspectCrop} from "react-image-crop";
import {FormItem, Input, Slider, Spinner} from "@vkontakte/vkui";
import InsertAlert from "./InsertAlert";
import {AiOutlineRotateRight} from "react-icons/ai";
import CropImage from "./CropImage";
import {
    printCropAspectForImg,
    enforcePrintCropAspectCrop,
    layoutCropPixelAspect,
    naturalSizeForModalCropFrame,
} from "../utils/printCropAspect";

/** Фильтр в консоли: [printorder:crop-after-load] */
function logCropAfterLoad(stage, payload) {
    try {
        console.log("[printorder:crop-after-load]", stage, payload);
    } catch (e) {
        /* ignore */
    }
}

/** Те же naturals, что для makeAspectCrop в onImageLoad — не ждать imageSize в state (один кадр с aspect=undefined). */
function naturalSizeForAspect(imgEl, imageSize) {
    if (imgEl && imgEl.naturalWidth > 0 && imgEl.naturalHeight > 0) {
        return {width: imgEl.naturalWidth, height: imgEl.naturalHeight};
    }
    if (imageSize && imageSize.width > 0 && imageSize.height > 0) {
        return imageSize;
    }
    return null;
}

/**
 * Размер превью в пикселях — тот же, что style width/height у ReactCrop (getWidthAndHeight).
 * Им для процентного кропа, а не BCR обёртки в DOM.
 */
function computePreviewLayoutForPercentCrop({
    borders,
    imgW,
    imgH,
    selectedSize,
    canvasWidth,
    rotate,
}) {
    const sizeCoef =
        selectedSize && selectedSize.coefficient != null
            ? Number(selectedSize.coefficient)
            : 1;
    if (!selectedSize) {
        return {width: canvasWidth, height: canvasWidth * sizeCoef};
    }
    if (borders !== "С полями") {
        if (!imgW || !imgH) {
            return {width: canvasWidth, height: canvasWidth};
        }
        if (imgW > imgH) {
            return {
                width: canvasWidth * sizeCoef,
                height: (canvasWidth * sizeCoef) * (imgH / imgW),
            };
        }
        const imgCoef = imgH / imgW;
        const height = canvasWidth * sizeCoef;
        return {width: height / imgCoef, height};
    }
    if (imgW && imgH) {
        if (imgW <= imgH) {
            if (rotate) {
                return {width: canvasWidth * sizeCoef, height: canvasWidth};
            }
            return {width: canvasWidth, height: canvasWidth * sizeCoef};
        }
        return {width: canvasWidth * sizeCoef, height: canvasWidth};
    }
    return {width: canvasWidth * sizeCoef, height: canvasWidth};
}

/** Как `planned` в onImageLoad — % кроп считается относительно этого бокса, не от imageSize из state. */
function previewLayoutFromNaturals(el, borders, selectedSize, canvasWidth, rotate) {
    const nw = el && el.naturalWidth > 0 ? el.naturalWidth : 0;
    const nh = el && el.naturalHeight > 0 ? el.naturalHeight : 0;
    const lay = computePreviewLayoutForPercentCrop({
        borders,
        imgW: nw,
        imgH: nh,
        selectedSize,
        canvasWidth,
        rotate,
    });
    let w = lay.width;
    let h = lay.height;
    if (!w || !h) {
        if (nw > 0 && nh > 0) {
            return {width: nw, height: nh};
        }
        return {width: canvasWidth, height: canvasWidth};
    }
    return {width: w, height: h};
}

const File = ({wh, defaultSize, popout, defaultBorders, deleteFile, saveFile, copyFile, types, item, sizes, openCrop, canvasWidth, selectFile, selectedFiles, photo}) => {
    const [crop, setCrop] = useState(item.hasOwnProperty("crop") ? item.crop : null)
    const [rotate, setRotate] = useState(item.hasOwnProperty("rotate") ? item.rotate : false)
    const [canvasSizes, setCanvasSizes] = useState()
    const [selectedSize, setSelectedSize] = useState(() => {
        if (item && Object.prototype.hasOwnProperty.call(item, "selectedSize") && item.selectedSize) {
            return item.selectedSize;
        }
        return defaultSize || (sizes && sizes[0]) || null;
    })

    const [imageSize, setImageSize] = useState(item.hasOwnProperty("imageSize") ? item.imageSize : null)

    const [borders, setBorders] = useState(
        item.hasOwnProperty("borders") ? item.borders : (defaultBorders || "Без полей")
    )
    const [typeValue, setTypeValue] = useState(item.hasOwnProperty("typeValue") ? item.typeValue : types[0])
    const imgRef = useRef();
    const [imgRef1, setImagRef1] = useState(null);
    const [cropImage, setCropImage] = useState(item.hasOwnProperty("cropImage") ? item.cropImage : null)
    const [cropModalNaturalSwap, setCropModalNaturalSwap] = useState(
        item.hasOwnProperty("cropModalNaturalSwap") ? item.cropModalNaturalSwap : false
    )
    const previewCanvasRef = useRef();
    const canvasNobordersRef = useRef();
    const imgBootstrappedRef = useRef(false);
    const loadPhaseRef = useRef(item.previewThumb ? "thumb" : "full");
    const previewSrcRef = useRef(Image.getDisplayUrl(photo, item.previewThumb));
    const fullSrcRef = useRef(Image.getFiles(photo));
    const [imgSrc, setImgSrc] = useState(() => Image.getDisplayUrl(photo, item.previewThumb));
    /** Пока false — грузится только превью; не вызываем initCanvas по уменьшенной копии. */
    const [fullImageReady, setFullImageReady] = useState(() => !item.previewThumb);
    /** Пока картинка для строки не отрисована (превью/thumb или полный кадр + canvas «с полями»). */
    const [photoRasterReady, setPhotoRasterReady] = useState(false);
    const sizesDrop = sizes.map(x => x.label);

    /* Сброс при смене файла / появлении server preview; переход thumb→full обрабатывается в loader.onload перед setImgSrc. */
    useEffect(() => {
        imgBootstrappedRef.current = false;
        setPhotoRasterReady(false);
    }, [photo, item.previewThumb]);

    useEffect(() => {
        previewSrcRef.current = Image.getDisplayUrl(photo, item.previewThumb);
        fullSrcRef.current = Image.getFiles(photo);
        loadPhaseRef.current = item.previewThumb ? "thumb" : "full";
        setFullImageReady(!item.previewThumb);
        setImgSrc(previewSrcRef.current);
        if (!item.previewThumb) {
            return;
        }
        const fullUrl = fullSrcRef.current;
        const loader = new window.Image();
        loader.crossOrigin = "anonymous";
        loader.onload = () => {
            setPhotoRasterReady(false);
            setImgSrc(fullUrl);
        };
        loader.onerror = () => {};
        loader.src = fullUrl;
    }, [photo, item.previewThumb]);

    useEffect(() => {
        saveFile("imageSize", imageSize)
        saveFile("borders", borders)
        saveFile("cropImage", cropImage)
        saveFile("typeValue", typeValue)
        saveFile("selectedSize", selectedSize)
        saveFile("rotate", rotate)
        saveFile("crop", crop)
        saveFile("cropModalNaturalSwap", cropModalNaturalSwap)

    }, [imageSize, borders, cropImage, typeValue, selectedSize, rotate, crop, cropModalNaturalSwap])
    useEffect(() => {
        if (!defaultSize) {
            return;
        }
        if (item && Object.prototype.hasOwnProperty.call(item, "selectedSize") && item.selectedSize) {
            return;
        }
        setSelectedSize(defaultSize);
    }, [defaultSize, item && item.photo, item && item.selectedSize && item.selectedSize.label])
    /* Только для новых файлов без сохранённого режима — не затирать borders из черновика defaultBorders. */
    useEffect(() => {
        if (!defaultBorders || !imageSize || !selectedSize || !imgRef1 || !imgRef.current) {
            return;
        }
        const persisted =
            item.borders === "С полями" ||
            item.borders === "Без полей";
        if (persisted) {
            return;
        }
        if (item.hasOwnProperty("owner_key")) {
            if (item.borders && item.borders !== "С полями") {
                selectBorders({value: item.borders}, false);
            }
            return;
        }
        selectBorders({value: defaultBorders}, true);
    }, [imageSize, selectedSize, imgRef1, defaultBorders, item.borders, item.owner_key])

    /** Бокс превью для % кропа = расчёт getWidthAndHeight, не BCR DOM. */
    const layoutForPercentCropPx = (imgEl) => {
        const nw =
            imgEl && imgEl.naturalWidth > 0 ? imgEl.naturalWidth : 0;
        const nh =
            imgEl && imgEl.naturalHeight > 0 ? imgEl.naturalHeight : 0;
        const sz =
            imageSize && imageSize.width > 0 && imageSize.height > 0
                ? imageSize
                : {width: nw, height: nh};
        const out = computePreviewLayoutForPercentCrop({
            borders,
            imgW: sz.width,
            imgH: sz.height,
            selectedSize,
            canvasWidth,
            rotate,
        });
        if (!out.width || !out.height) {
            if (nw > 0 && nh > 0) {
                return {width: nw, height: nh};
            }
            return {width: canvasWidth, height: canvasWidth};
        }
        return out;
    };

    const type = [
        'Глянцеваяя', 'Матовая'
    ];
    const defaultType = type[0];
    const onImageLoad = (e) => {
        const el = e.currentTarget;
        if (imgBootstrappedRef.current && loadPhaseRef.current !== "waiting-full") {
            return;
        }
        if (loadPhaseRef.current === "thumb") {
            const srcNow = String(el.currentSrc || el.src || "");
            const previewSrc = String(previewSrcRef.current || "");
            const isPreviewFrame = previewSrc && srcNow === previewSrc;
            if (isPreviewFrame) {
                loadPhaseRef.current = "waiting-full";
                /* В «Без полей» спиннер держим до второго onLoad (полный файл) и полного перерасчёта canvas/crop. */
                imgBootstrappedRef.current = false;
                return;
            }
            /* Гонка: preload full мог завершиться раньше thumb onLoad — тогда сразу обрабатываем как full. */
            loadPhaseRef.current = "full";
        }
        if (loadPhaseRef.current === "waiting-full") {
            loadPhaseRef.current = "full";
        }

        setFullImageReady(true);
        const nw = el.naturalWidth;
        const nh = el.naturalHeight;
        /** Бокс превью как у style ReactCrop (getWidthAndHeight), по натуральным размерам этого кадра. */
        const planned = computePreviewLayoutForPercentCrop({
            borders,
            imgW: nw,
            imgH: nh,
            selectedSize,
            canvasWidth,
            rotate,
        });
        let dispW = planned.width;
        let dispH = planned.height;
        if (!dispW || !dispH) {
            dispW = nw;
            dispH = nh;
        }
        if (!imageSize) {
            setImageSize({width: nw, height: nh})
        } else if (imageSize.width !== nw || imageSize.height !== nh) {
            /* Черновик / смена файла: не держать старые размеры — иначе ReactCrop aspect ≠ расчёт по картинке. */
            setImageSize({width: nw, height: nh})
        }

        saveFile("canvas", previewCanvasRef.current)
        saveFile("canvas_noborders", canvasNobordersRef.current)
        const withFields = borders === "С полями";
        const printCropAspect = printCropAspectForImg(selectedSize, nw, nh, rotate);
        const defaultPctCrop = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 100,
                },
                printCropAspect,
                dispW,
                dispH
            ),
            dispW,
            dispH
        );
        let cropd = withFields ? defaultPctCrop : (item.crop ? item.crop : defaultPctCrop);
        if (!withFields && selectedSize) {
            const beforeAspect = layoutCropPixelAspect(cropd, dispW, dispH);
            cropd = enforcePrintCropAspectCrop({
                crop: cropd,
                layoutW: dispW,
                layoutH: dispH,
                printSize: selectedSize,
                naturalW: nw,
                naturalH: nh,
                rotate,
            });
            const afterAspect = layoutCropPixelAspect(cropd, dispW, dispH);
            if (
                beforeAspect != null &&
                afterAspect != null &&
                Math.abs(beforeAspect - afterAspect) > 1e-6
            ) {
                logCropAfterLoad("File.onImageLoad:enforceAspect", {
                    fileIndex: wh,
                    photo: item && item.photo,
                    beforeAspect,
                    afterAspect,
                    expected: printCropAspect,
                });
            }
        }
        const naturalLandscape = nw >= nh || (rotate && nw === nh);
        const aspectIfPropUsedStateOnly =
            imageSize && selectedSize
                ? printCropAspectForImg(selectedSize, imageSize.width, imageSize.height, rotate)
                : null;
        const szForAspect = naturalSizeForAspect(el, imageSize);
        const aspectLikeReactCropAfterFix =
            selectedSize && szForAspect
                ? printCropAspectForImg(selectedSize, szForAspect.width, szForAspect.height, rotate)
                : null;
        logCropAfterLoad("File.onImageLoad", {
            fileIndex: wh,
            photo: item && item.photo,
            borders: withFields ? "С полями" : "Без полей",
            naturalPx: {w: nw, h: nh},
            natural_w_over_h: nh ? nw / nh : null,
            naturalLandscape,
            rotate: Boolean(rotate),
            layoutForPercentCrop: {w: dispW, h: dispH},
            stateImageSizeBeforeSet: imageSize,
            mismatchNaturalVsState: Boolean(
                imageSize && (imageSize.width !== nw || imageSize.height !== nh)
            ),
            printMm: selectedSize && {
                label: selectedSize.label,
                w: selectedSize.width,
                h: selectedSize.height,
                coef: selectedSize.coefficient,
            },
            printCropAspect_fromNatural: printCropAspect,
            /* Раньше: aspect у ReactCrop только из imageSize → в этом кадре null, хотя кроп уже по natural. */
            printCropAspect_ifPropStateOnly: aspectIfPropUsedStateOnly,
            printCropAspect_likeRenderedNow: aspectLikeReactCropAfterFix,
            reactCrop_aspect_wasUndefinedWithStateOnly: aspectIfPropUsedStateOnly == null,
            reactCrop_aspect_fixedMatchesOnLoad:
                aspectLikeReactCropAfterFix != null &&
                Math.abs(aspectLikeReactCropAfterFix - printCropAspect) < 1e-6,
            aspectRule: naturalLandscape
                ? "landscape: printCropAspect = printH_mm/printW_mm"
                : "portrait: printCropAspect = printW_mm/printH_mm",
            defaultPctCrop,
            cropdApplied: cropd,
            cropLayoutAspect: layoutCropPixelAspect(cropd, dispW, dispH),
            cropdSource: withFields
                ? "только default (с полями)"
                : item.crop
                    ? "item.crop из черновика → проверен enforce"
                    : "defaultPctCrop; затем initCanvas может вызвать callback(%)",
            initCanvasWillPassCallback: !withFields && !item.crop,
        });
        setCrop(cropd);

        if (withFields) {
            Image.initCanvas(previewCanvasRef.current, el, true, selectedSize, null, false);
        } else {
            Image.initCanvas(
                previewCanvasRef.current,
                el,
                false,
                selectedSize,
                item.crop ? null : callback,
                rotate
            );
        }

        /* Сразу result canvas — те же dispW/dispH и cropd, что enforce в этом же onImageLoad (важно для дубликата). */
        if (
            !withFields &&
            canvasNobordersRef.current &&
            el.naturalWidth >= 2 &&
            selectedSize
        ) {
            try {
                if (
                    item.cropImage &&
                    item.cropImage.unit === "px" &&
                    Number(item.cropImage.width) > 0 &&
                    Number(item.cropImage.height) > 0
                ) {
                    Image.cropCanvas(
                        canvasNobordersRef.current,
                        {current: el},
                        item.cropImage
                    );
                    saveFile("canvas_noborders", canvasNobordersRef.current);
                } else if (cropd && cropd.unit === "%" && dispW > 0 && dispH > 0) {
                    const px0 = convertToPixelCrop(cropd, dispW, dispH);
                    Image.cropCanvas(
                        canvasNobordersRef.current,
                        {current: el},
                        px0
                    );
                    saveFile("canvas_noborders", canvasNobordersRef.current);
                }
            } catch (e) {
                /* ignore */
            }
        }

        setImagRef1(el);
        setPhotoRasterReady(true);
        imgBootstrappedRef.current = true;
    }

    useEffect(() => {
        if (!fullImageReady || borders !== "С полями") {
            return;
        }
        if (!imgRef.current) {
            return;
        }
        setRotate(false);
        saveFile("rotate", false);
        Image.initCanvas(previewCanvasRef.current, imgRef.current, true, selectedSize, null, false);
    }, [selectedSize, fullImageReady, borders])

    const saveMe = (crop, imgRefd, meta) => {
        const cropImgEl = imgRefd && imgRefd.current ? imgRefd.current : imgRef.current;
        if (!crop) {
            return;
        }
        if (meta && typeof meta.modalNaturalSwap === "boolean") {
            setCropModalNaturalSwap(meta.modalNaturalSwap);
        }
        const swapForEnforce =
            meta && typeof meta.modalNaturalSwap === "boolean"
                ? meta.modalNaturalSwap
                : cropModalNaturalSwap;
        if (crop.unit === "%") {
            let next = crop;
            if (borders !== "С полями" && cropImgEl && selectedSize) {
                const lay = layoutForPercentCropPx(cropImgEl);
                const cw = lay.width;
                const ch = lay.height;
                const {naturalW, naturalH} = naturalSizeForModalCropFrame(cropImgEl, swapForEnforce);
                next = enforcePrintCropAspectCrop({
                    crop,
                    layoutW: cw,
                    layoutH: ch,
                    printSize: selectedSize,
                    naturalW,
                    naturalH,
                    rotate,
                });
                if (canvasNobordersRef.current) {
                    try {
                        const px = convertToPixelCrop(next, cw, ch);
                        const sourceEl =
                            imgRef.current && fullImageReady ? imgRef.current : cropImgEl;
                        Image.cropCanvas(canvasNobordersRef.current, {current: sourceEl}, px);
                        saveFile("canvas_noborders", canvasNobordersRef.current);
                    } catch (e) {
                        /* ignore */
                    }
                }
            }
            setCrop(next);
            /* После сохранения из модалки работаем от актуального % кропа.
               Иначе старый cropImage(px) перехватывает рендер canvas_noborders до смены размера. */
            setCropImage(null);
        } else {
            setCropImage(crop);
            if (cropImgEl && canvasNobordersRef.current) {
                Image.cropCanvas(canvasNobordersRef.current, {current: cropImgEl}, crop);
            }
        }
        saveFile("canvas", previewCanvasRef.current);
        saveFile("canvas_noborders", canvasNobordersRef.current);
    }
    useEffect(() => {

    }, [cropImage, imgRef, previewCanvasRef])

    /* После смены layout/черновика: рамка % должна совпадать с ориентацией печати; иначе пересчёт. */
    useLayoutEffect(() => {
        if (borders === "С полями" || !crop || !selectedSize || !imgRef.current || !fullImageReady) {
            return;
        }
        const el = imgRef.current;
        if (el.naturalWidth < 2 || el.naturalHeight < 2) {
            return;
        }
        const lay = layoutForPercentCropPx(el);
        const cw = lay.width;
        const ch = lay.height;
        if (!cw || !ch) {
            return;
        }
        const {naturalW, naturalH} = naturalSizeForModalCropFrame(el, cropModalNaturalSwap);
        const expected = printCropAspectForImg(selectedSize, naturalW, naturalH, rotate);
        const actual = layoutCropPixelAspect(crop, cw, ch);
        if (actual == null) {
            return;
        }
        const relErr = Math.abs(actual - expected) / Math.max(expected, actual, 1e-9);
        if (relErr <= 0.015) {
            return;
        }
        const fixed = enforcePrintCropAspectCrop({
            crop,
            layoutW: cw,
            layoutH: ch,
            printSize: selectedSize,
            naturalW,
            naturalH,
            rotate,
        });
        setCrop(fixed);
    }, [borders, crop, selectedSize, rotate, fullImageReady, photo, wh, cropModalNaturalSwap]);

    /* «Без полей»: превью заказа берёт canvas_noborders — рисуем из % или из px (модалка). */
    useLayoutEffect(() => {
        if (borders === "С полями") {
            return;
        }
        if (!fullImageReady || !imgRef.current || !canvasNobordersRef.current) {
            return;
        }
        const el = imgRef.current;
        if (el.naturalWidth < 2 || el.naturalHeight < 2) {
            return;
        }
        if (!selectedSize) {
            return;
        }
        try {
            if (
                cropImage &&
                cropImage.unit === "px" &&
                Number(cropImage.width) > 0 &&
                Number(cropImage.height) > 0
            ) {
                Image.cropCanvas(canvasNobordersRef.current, {current: el}, cropImage);
                saveFile("canvas_noborders", canvasNobordersRef.current);
                return;
            }
            if (!crop || crop.unit !== "%") {
                return;
            }
            const lay = previewLayoutFromNaturals(
                el,
                borders,
                selectedSize,
                canvasWidth,
                rotate
            );
            const cw = lay.width;
            const ch = lay.height;
            if (!cw || !ch) {
                return;
            }
            const px = convertToPixelCrop(crop, cw, ch);
            Image.cropCanvas(canvasNobordersRef.current, {current: el}, px);
            saveFile("canvas_noborders", canvasNobordersRef.current);
        } catch (e) {
            /* ignore */
        }
    }, [borders, crop, cropImage, fullImageReady, selectedSize, rotate, photo, wh, canvasWidth]);

    const callback = (crop) => {
        const imgEl = imgRef.current;
        let next = crop;
        if (imgEl && selectedSize) {
            const lay = layoutForPercentCropPx(imgEl);
            const cw = lay.width;
            const ch = lay.height;
            next = enforcePrintCropAspectCrop({
                crop,
                layoutW: cw,
                layoutH: ch,
                printSize: selectedSize,
                naturalW: imgEl.naturalWidth,
                naturalH: imgEl.naturalHeight,
                rotate,
            });
        }
        logCropAfterLoad("Image.initCanvas→callback(%)", {
            fileIndex: wh,
            photo: item && item.photo,
            cropFromInitCanvas: crop,
            cropAfterEnforce: next,
        });
        setCrop(next)
    }
    const selectBorders = (e, mb = false) => {
        if (!imgRef.current) {
            return false;
        }
        if (imgRef.current.naturalWidth < 2 || imgRef.current.naturalHeight < 2) {
            return false;
        }
        setBorders(e.value)
        saveFile("borders", e.value)
        if (e.value === "С полями") {
            setRotate(false)
            saveFile("rotate", false)
            Image.initCanvas(previewCanvasRef.current, imgRef.current, true, selectedSize, null, false)
        } else {
            const nw0 = imgRef.current.naturalWidth;
            const nh0 = imgRef.current.naturalHeight;
            const lay0 = layoutForPercentCropPx(imgRef.current);
            const dw0 = lay0.width;
            const dh0 = lay0.height;
            const pca = printCropAspectForImg(selectedSize, nw0, nh0, rotate);
            const cropd = centerCrop(
                makeAspectCrop(
                    {
                        unit: '%',
                        width: 100,
                    },
                    pca,
                    dw0,
                    dh0
                ),
                dw0,
                dh0
            )
            //setCropImage(cropd)
            setCrop(cropd)
            Image.initCanvas(previewCanvasRef.current, imgRef.current, false, selectedSize, callback, rotate)

            if (!mb)
                openCrop(saveMe, imageSize, selectedSize, cropd, true, rotate, cropModalNaturalSwap)
            else {
                const crop_px = centerCrop(
                    makeAspectCrop(
                        {
                            unit: 'px',
                            width: dw0,
                        },
                        pca,
                        dw0,
                        dh0
                    ),
                    dw0,
                    dh0
                );

                Image.cropCanvas(document.querySelector(`.result_canvas_${wh}`), imgRef, crop_px)

            }

        }
    }
    const [cropHI, sertCr] = useState(null)
    const showCropSelection = borders !== "С полями";
    const openMeCrop = (saveMe, imageSize, selectedSize, cropd, hidden) => {
        sertCr(
            <CropImage hidden={hidden} imageSize={imageSize} selectedSize={selectedSize} cropInit={crop} rotate={rotate}
                       modalNaturalSwap={cropModalNaturalSwap}
                       closePop={(id) => sertCr(null)} savePop={(crop, imgRef, meta) => {
                saveMe(crop, imgRef, meta)
            }} dk={wh} file={item}/>
        )
    }
    const selectSize = (e) => {
        const findSize = sizes.find(x => x.label === e.value);
        saveFile("size", e.value);
        if (!imgRef.current || imgRef.current.naturalWidth < 2) {
            setSelectedSize(findSize);
            setCropImage(null);
            return;
        }
        const nw1 = imgRef.current.naturalWidth;
        const nh1 = imgRef.current.naturalHeight;
        /* Новый формат печати — сразу layout и кроп от него (setSelectedSize ещё async, нельзя layoutForPercentCropPx). */
        const lay1 = previewLayoutFromNaturals(
            imgRef.current,
            borders,
            findSize,
            canvasWidth,
            rotate
        );
        const dw1 = lay1.width;
        const dh1 = lay1.height;
        setCropImage(null);
        setCropModalNaturalSwap(false);
        const pca1 = printCropAspectForImg(findSize, nw1, nh1, rotate);
        let cropd = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 100,
                },
                pca1,
                dw1,
                dh1
            ),
            dw1,
            dh1
        );
        if (borders !== "С полями" && findSize) {
            cropd = enforcePrintCropAspectCrop({
                crop: cropd,
                layoutW: dw1,
                layoutH: dh1,
                printSize: findSize,
                naturalW: nw1,
                naturalH: nh1,
                rotate,
            });
        }
        setCrop(cropd);
        setSelectedSize(findSize);
        if (borders !== "С полями") {
            Image.initCanvas(
                previewCanvasRef.current,
                imgRef.current,
                false,
                findSize,
                null,
                rotate
            );
            saveFile("canvas", previewCanvasRef.current);
            saveFile("canvas_noborders", canvasNobordersRef.current);
        } else {
            Image.initCanvas(
                previewCanvasRef.current,
                imgRef.current,
                true,
                findSize,
                null,
                rotate
            );
        }
    }

    const getWidthAndHeight = () => {
        const iw =
            imageSize && imageSize.width > 0 ? imageSize.width : 0;
        const ih =
            imageSize && imageSize.height > 0 ? imageSize.height : 0;
        return computePreviewLayoutForPercentCrop({
            borders,
            imgW: iw,
            imgH: ih,
            selectedSize,
            canvasWidth,
            rotate,
        });
    }
    const handleClick = (e) => {

        switch (e.detail) {
            case 1:
                if (borders !== "С полями")
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                        openCrop(saveMe, imageSize, selectedSize, crop, false, rotate, cropModalNaturalSwap)
                    }
                break
            case 2:
                if (borders !== "С полями") {
                    openCrop(saveMe, imageSize, selectedSize, crop, false, rotate, cropModalNaturalSwap)

                }
                break;
        }
    }
    useEffect(() => {
        if (!fullImageReady || !imgRef.current || borders !== "С полями") {
            return;
        }
        Image.initCanvas(
            previewCanvasRef.current,
            imgRef.current,
            true,
            selectedSize,
            null,
            rotate
        );
    }, [rotate, fullImageReady, selectedSize, borders])

    const sizeForCropAspect = naturalSizeForAspect(imgRef.current, imageSize);

    return (
        <div className={"file"} style={{display: "flex"}}>
            <div className={"file_buttons"}>
                {/*<button onClick={selectFile}>
                    <AiFillCheckCircle color={selectedFiles.indexOf(wh) !== -1 ? "green" : "black"} size={20}/>
                </button>*/}
                <button disabled={!imageSize || borders === "С полями"}
                        onClick={() => openCrop(saveMe, imageSize, selectedSize, crop, false, rotate, cropModalNaturalSwap)}>
                    <RiCrop2Line size={20}/>
                </button>
                <button
                    disabled={!borders || borders === "Без полей" || !imageSize}
                    onClick={() => {
                        saveFile("rotate", !rotate)
                        setRotate(prevState => !prevState)
                    }}>
                    {rotate ?
                        <AiOutlineRotateLeft size={20}/> :
                        <AiOutlineRotateRight size={20}/>
                    }
                </button>
                <button onClick={() => copyFile()}>
                    <BiCopy size={20}/>
                </button>
                <button type="button" onClick={() => deleteFile()}>
                    <RiDeleteBin6Line size={20} color={"red"}/>
                </button>
            </div>
            <button className={"file_photo2"} onClick={handleClick}>
                <ReactCrop
                    key={`${photo}-${selectedSize && selectedSize.label}`}
                    disabled={true} crop={showCropSelection ? crop : undefined}
                    onComplete={c => {

                        setCropImage(c)

                    }}
                    onChange={c => {
                        setCrop(c)
                    }}
                    aspect={
                        showCropSelection && selectedSize && sizeForCropAspect
                            ? printCropAspectForImg(
                                selectedSize,
                                sizeForCropAspect.width,
                                sizeForCropAspect.height,
                                rotate
                            )
                            : undefined
                    }
                    style={
                        {
                            width: getWidthAndHeight().width/*getWidthAndHeight().width + 40*/,
                            height: getWidthAndHeight().height,
                        }
                    }
                    className={`file_photo ${borders === "С полями" ? "no_crop_preview" : ""} ${rotate ? 'rotate' : ''}`}>

                    <img
                        key={`${photo}__${imgSrc}`}
                        style={{
                            display: borders === "С полями" ? "none" : "block",
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            opacity: photoRasterReady ? 1 : 0,
                        }}
                        ref={imgRef}
                        onLoad={onImageLoad}
                        onError={() => setPhotoRasterReady(true)}
                        crossOrigin="anonymous"
                        src={imgSrc}
                    />

                    {!photoRasterReady ? (
                        <div className="file_photo_loading_overlay" aria-hidden>
                            <Spinner size="large"/>
                        </div>
                    ) : null}

                    {selectedSize && imageSize && (selectedSize.minSize >= Image.getMinSize(imageSize) ?
                        <InsertAlert selectedSize={selectedSize.minSize} Image={Image.getMinSize(imageSize)}
                                     imageSize={imageSize}/> : null)}
                    <canvas

                        className={"photo"}
                        ref={previewCanvasRef}
                        style={{
                            opacity: borders === "С полями" ? 1 : 0
                            // Rounding is important for sharpness.

                        }}
                    />
                </ReactCrop>
            </button>
            <canvas ref={canvasNobordersRef} className={`result_canvas_${wh}`}
                    style={
                        {
                            alignSelf: "center",
                            display: "none",
                            width: cropImage && cropImage.width / selectedSize.coefficient,
                            height: cropImage && cropImage.height / selectedSize.coefficient,
                        }
                    }
            />
            {item && item.hasOwnProperty("keke") && (item.keke)}


            <div className={"file_down"}>

                <Dropdown controlClassName={"d53"} className={"d3"} options={sizesDrop} onChange={selectSize}
                          value={selectedSize.label}
                          placeholder="Выберите размер"/>


                {/* <Dropdown options={types} value={typeValue} onChange={(e) => {
                    setTypeValue(e.value)
                    saveFile("type", e.value)
                }} placeholder="Выберите тип"/>*/}
                <div className={"borders_switch"}>
                    <button
                        type="button"
                        className={borders === "Без полей" ? "active" : ""}
                        onClick={() => selectBorders({value: "Без полей"})}
                    >
                        Без полей
                    </button>
                    <button
                        type="button"
                        className={borders === "С полями" ? "active" : ""}
                        onClick={() => selectBorders({value: "С полями"})}
                    >
                        С полями
                    </button>
                </div>
                {/*{borders !== "С полями" &&
                <span className={"font_montserrat w_700"}
                      style={{color: "red", textAlign: "center", marginBottom: 20, maxWidth: "100%", fontSize: 13}}>Не забудьте сохранить кадрирование</span>
                }*/}

                <div style={{height: "40px !important"}} className={"count_of_file"}>
                    <button
                        onClick={() => {
                            if (item.hasOwnProperty("count") && item.count > 1)
                                saveFile("count", item.count - 1)
                        }}
                        style={{
                            fontSize: 25,
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column"
                        }} className={"font_montserrat w_700"}>
                        <span>-</span>
                    </button>
                    <input
                        style={{
                            height: 35.6
                        }}
                        onChange={(e) => {
                            saveFile("count", parseInt(e.currentTarget.value) ? parseInt(e.currentTarget.value) : 1)
                        }}
                        className={"font_montserrat w_700 count_input"} value={item.count ? item.count : 1}/>
                    <button
                        onClick={() => {
                            saveFile("count", item.hasOwnProperty("count") ? item.count + 1 : 2)
                        }}
                        style={{
                            fontSize: 25,
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column"
                        }} className={"font_montserrat w_700"}>
                        <span>+</span>
                    </button>
                </div>

            </div>
            {cropHI}
        </div>
    )
}
export default File